<template>
  <!--
    Diagrama interativo do Ciclo Mensal de Resultados e Reuniões.
    Aberto pelo botão de tutoriais quando o usuário está na tela inicial (/app).
    Cada etapa é clicável e abre o vídeo tutorial correspondente.
  -->
  <v-dialog v-model="show" max-width="1300" scrollable @click:outside="fechar">
    <v-card class="fluxo-card">
      <v-toolbar dark color="blue darken-3" dense class="flex-grow-0">
        <v-icon left>mdi-sitemap</v-icon>
        <v-toolbar-title>Tutorial do Ciclo Mensal de Resultados</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4 fluxo-scroll-area">
        <p class="text-body-2 grey--text text--darken-1 mb-4">
          Clique em uma etapa para assistir ao tutorial correspondente.
        </p>

        <div class="fluxo-blocos">
          <template v-for="(bloco, bIndex) in blocos">
            <div :key="bloco.key" class="fluxo-bloco">
              <div class="fluxo-bloco-header" :class="bloco.cor">{{ bloco.titulo }}</div>
              <div class="fluxo-bloco-cards">
                <div
                  v-for="etapa in passosPorBloco(bloco.key)"
                  :key="etapa.numero"
                  class="fluxo-etapa-group"
                >
                  <v-card outlined class="fluxo-etapa-card" @click="assistir(etapa)">
                    <v-icon small color="blue darken-3" class="fluxo-etapa-play">mdi-play-circle-outline</v-icon>
                    <div class="fluxo-etapa-numero">{{ etapa.numero }}</div>
                    <v-chip x-small label color="blue lighten-4" class="mb-1">{{ etapa.papel }}</v-chip>
                    <div class="fluxo-etapa-titulo">{{ etapa.titulo }}</div>
                    <div class="fluxo-etapa-descricao">{{ etapa.descricao }}</div>
                  </v-card>

                  <!-- Material complementar da etapa (ex: vídeos de Plano de Ação nos passos 5 e 7) -->
                  <v-card
                    v-if="etapa.extra"
                    outlined
                    class="fluxo-extra-card"
                    @click="assistir(etapa.extra)"
                  >
                    <v-icon small color="blue darken-3">mdi-play-circle-outline</v-icon>
                    <span class="fluxo-extra-titulo">{{ etapa.extra.titulo }}</span>
                  </v-card>
                </div>
              </div>
            </div>
            <v-icon
              v-if="bIndex < blocos.length - 1"
              :key="'arrow-' + bloco.key"
              class="fluxo-arrow"
              color="blue darken-2"
            >
              mdi-arrow-right-bold
            </v-icon>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { FLUXO_TRABALHO, FLUXO_BLOCOS } from '@/config/fluxoTrabalho.config'

export default {
  name: 'TutorialFluxoDialog',
  data: () => ({
    show: false,
    blocos: FLUXO_BLOCOS,
    passos: FLUXO_TRABALHO,
  }),
  methods: {
    // Chamado pelo plugin $tutorial.abrirFluxo()
    abrir() {
      this.show = true
    },
    fechar() {
      this.show = false
    },
    passosPorBloco(key) {
      return this.passos.filter(p => p.bloco === key)
    },
    // Abre o vídeo da etapa direto no player, reaproveitando o dialog de tutoriais existente
    assistir(etapa) {
      this.$tutorial.abrirLista([etapa.tutorial])
    },
  },
}
</script>

<style scoped>
.fluxo-card {
  display: flex;
  flex-direction: column;
  max-height: 85vh;
}
.fluxo-scroll-area {
  overflow-y: auto;
}
.fluxo-blocos {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow-x: auto;
}
.fluxo-bloco {
  flex: 1 1 0;
  min-width: 220px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}
.fluxo-bloco-header {
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 8px;
}
.fluxo-bloco-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background: #fafafa;
}
.fluxo-etapa-group {
  /* Faz os v-card filhos se comportarem como itens diretos do flex column
     da coluna do bloco, mantendo o mesmo espaçamento (gap) entre todos os cards. */
  display: contents;
}
.fluxo-etapa-card {
  position: relative;
  padding: 12px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.fluxo-extra-card {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  cursor: pointer;
  background: #e3f2fd;
  transition: box-shadow 0.2s;
}
.fluxo-extra-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.fluxo-extra-titulo {
  font-size: 12px;
  font-weight: 600;
  color: #1565c0;
}
.fluxo-etapa-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.fluxo-etapa-numero {
  font-size: 26px;
  font-weight: 700;
  color: #1565c0;
  line-height: 1.2;
}
.fluxo-etapa-titulo {
  font-weight: 600;
  margin-top: 2px;
}
.fluxo-etapa-descricao {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}
.fluxo-etapa-play {
  position: absolute;
  top: 8px;
  right: 8px;
}
.fluxo-arrow {
  align-self: center;
  margin-top: 90px;
}
</style>
